import { Fab } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const WhatsAppConnect: React.FC = () => {
  const phoneNumber = "+918547486582"; // Replace with your WhatsApp number (with country code)
  const preFilledMessage = "Hello! I need more information."; // Pre-filled message when the user clicks the button

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(preFilledMessage)}`;

  return (
    <Fab
      color="success"
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        position: "fixed",
        bottom: 16,
        right: 16,
      }}
    >
      <WhatsAppIcon />
    </Fab>
  );
};

export default WhatsAppConnect;
